export enum PaymentTerm {
  FixedTerm = 'FT',
  MPM = 'MPM',
  MPA = 'MPA',
  IndefinitePayMonthly = 'IPM',
}
